export enum SaleOrderStatusEnum {
    OPEN = 'OPEN',
    IN_PROGRESS = 'IN_PROGRESS',
    CANCELLED = 'CANCELLED',
    HOLD = 'HOLD',
    LOADED_AND_SEALED = 'LOADED AND SEALED',
    SHIPPED = 'SHIPPED',
    CLOSED = 'CLOSED',
}